module.exports = __webpack_public_path__ + "img/1.63073468.png";